import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

export const escapeHtml = (unsafeHtml: string) =>
  unsafeHtml
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

export const normalizeString = (str: string, trim = true) => {
  if (trim)
    return str
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  return str
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

export const highlight = (str: string, keyword: string) => {
  const normalizedString = normalizeString(str, false);
  const normalizedKeyword = normalizeString(keyword);
  if (!normalizedKeyword) return escape(str);
  const matches = match(normalizedString, normalizedKeyword, {
    findAllOccurrences: true,
    insideWords: true,
  });
  const parsed = parse(str, matches);
  return parsed
    .map(fragment =>
      fragment.highlight
        ? `<span style="font-weight: bold;">${escape(fragment.text)}</span>`
        : escape(fragment.text)
    )
    .join('');
};
